import React, { useMemo } from 'react';
import Modal from './Modal';
import UserAlert from 'models/UserAlert';
import ActionButton from '../buttons/ActionButton';

import 'view/style/common/notifications.css';

const wormy_teacher = require('assets/images/logos/wormy-teacher.png');
const wormy_student = require('assets/images/logos/wormy-student.png');
const wormy_funky = require('assets/images/logos/funky-worm.png');

type UserAlertPopupProps = {
  alert: UserAlert;
  onClose: () => void;
};

// Generic alert popup

const GenericPopup: React.FC<UserAlertPopupProps> = ({ alert, onClose }) => {
  return (
    <div className="user-alert-popup">
      <div className="row">
        <img src={wormy_funky} alt="Orator" />
        <div className="col">
          <h2>{alert.title}</h2>
          <p>{alert.message}</p>
          <ActionButton label="I'm ready!" type="go" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

// First time login popup

const FirstLoginPopup: React.FC<UserAlertPopupProps> = ({ alert, onClose }) => {
  const handleClose = () => {
    if (onClose) onClose();

    // After closing the popup, find the button and trigger a click
    setTimeout(() => {
      const joinButton = document.getElementById(
        'join-classroom-button',
      ) as HTMLButtonElement | null;
      if (joinButton) {
        joinButton.click();
      }
    }, 100); // slight delay to make sure popup close animation finishes
  };

  return (
    <div className="user-alert-popup">
      <div className="row">
        <img src={wormy_teacher} alt="Orator" />
        <div className="col">
          <h2>{alert.title}</h2>
          <p>{alert.message}</p>
          <ActionButton label="I'm ready!" type="go" onClick={handleClose} />
        </div>
      </div>
    </div>
  );
};

// First classroom popup

const FirstClassroomPopup: React.FC<UserAlertPopupProps> = ({
  alert,
  onClose,
}) => {
  const handleClose = () => {
    if (onClose) onClose();

    // After closing the popup, find the button and trigger a click
    setTimeout(() => {
      const joinButton = document.getElementById(
        'add-students-button',
      ) as HTMLButtonElement | null;
      if (joinButton) {
        joinButton.click();
      }
    }, 100); // slight delay to make sure popup close animation finishes
  };

  return (
    <div className="user-alert-popup">
      <div className="row">
        <img src={wormy_student} alt="Orator" />
        <div className="col">
          <h2>{alert.title}</h2>
          <p>{alert.message}</p>
          <ActionButton label="I'm ready!" type="go" onClick={handleClose} />
        </div>
      </div>
    </div>
  );
};

const POPUPS: Record<string, React.FC<UserAlertPopupProps>> = {
  first_time_login: FirstLoginPopup,
  first_classroom: FirstClassroomPopup,
};

const UserAlertPopup: React.FC<UserAlertPopupProps> = ({ alert, onClose }) => {
  const PopupComponent = useMemo(() => {
    if (alert.key in POPUPS) {
      return POPUPS[alert.key];
    }

    return GenericPopup;
  }, [alert]);

  return (
    <Modal isOpen={alert !== undefined}>
      <PopupComponent alert={alert} onClose={onClose} />
    </Modal>
  );
};

export default UserAlertPopup;
